/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A11Inputs */

const et_faq_a11 = /** @type {(inputs: Faq_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScalingWebs pakub tulemuspõhist veebiarenduse, lokaalse SEO ja konversiooni optimeerimise teenust ettevõtetele, kes tahavad rohkem päringuid, mitte lihtsalt uut kodulehte. Meie fookus on Google'i nähtavusel, Google Mapsi esiletõusul, müügilehtedel, CRM-integratsioonidel ja AI-toega automaatikal. Töötame mudeliga, kus eesmärgid seotakse nähtavuse ja päringute kasvuga. See tähendab, et hindame edu selle järgi, kas sinu ettevõte saab rohkem kvaliteetseid ärivõimalusi.`)
};

const en_faq_a11 = /** @type {(inputs: Faq_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScalingWebs offers results-driven web development, local SEO, and conversion optimization for companies that want more inquiries, not just a new website. Our focus is Google visibility, Google Maps prominence, sales pages, CRM integrations, and AI-powered automation. We work with a model where goals are tied to visibility and inquiry growth. That means we measure success by whether your business gets more high-quality opportunities.`)
};

/**
* | output |
* | --- |
* | "ScalingWebs offers results-driven web development, local SEO, and conversion optimization for companies that want more inquiries, not just a new website. Our..." |
*
* @param {Faq_A11Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a11 = /** @type {((inputs?: Faq_A11Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A11Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a11(inputs)
	return en_faq_a11(inputs)
});